"use strict";

define('rs/models/meeting',['rs/models/abstract', 'rs/models/meeting.document', 'rs/models/meeting.person', 'rs/models/group', 'moment'], function (RSAbstractModel, MeetingDocument, MeetingPerson, Group, moment) {
  var Meeting = RSAbstractModel.extend({
    properties: ['activityDate', 'agenda', 'board', 'meetingDocuments', 'meetingPeople', 'endDate', 'group', 'id', 'location', 'people', 'startDate', 'title', 'updateUserAuthId', 'version'],
    serverProperties: ['activityDate', 'agenda', 'endDate', 'group', 'id', 'location', 'startDate', 'title', 'updateUserAuthId', 'version'],
    initialize: function initialize() {
      this._super.apply(this, arguments);
      if (!this.getMeetingDocuments()) {
        this.setDocuments([]);
      }
      if (!this.getMeetingPeople()) {
        this.setPeople([]);
      }
      if (this.getStartDate()) {
        this.setStartDate(new Date(this.getStartDate()));
      } else {
        var date = moment(new Date()).add(60, 'minute').toDate(),
          time = date.getMinutes() - date.getMinutes() % 15;
        date.setMinutes(time);
        this.setStartDate(date);
      }
      if (this.getEndDate()) {
        this.setEndDate(new Date(this.getEndDate()));
      } else {
        this.setEndDate(moment(this.getStartDate()).add(30, 'minute').toDate());
      }
      if (this.getGroup()) {
        this.setBoard(Group.model(this.getGroup()));
      }
      if (this.getEndDate().getTime() >= new Date().getTime()) {
        this.started = false;
      } else {
        this.started = true;
      }
    },
    setDocuments: function setDocuments(documents) {
      this.setMeetingDocuments(MeetingDocument.models(documents));
      _.invoke(this.getMeetingDocuments(), 'setMeeting', this);
    },
    setPeople: function setPeople(people) {
      this.setMeetingPeople(MeetingPerson.models(people));
      _.invoke(this.getMeetingPeople(), 'setMeetingId', this.getId());
    },
    requestAndSetBoard: function requestAndSetBoard(board) {
      var that = this;
      return Promise.resolve(board ? board.requestMembers() : null).then(function () {
        that.setBoard(board);
        return that;
      });
    },
    setBoard: function setBoard(board, silent) {
      var that = this;
      this.iterateBoardPeople(this.getBoard(), function (person) {
        that.removePerson(person);
      });
      if (board) {
        this.setTitle(board.getName());
        this.setGroup({
          id: board.getId()
        });
      } else {
        this.setTitle('');
        this.setGroup(null);
      }
      this.iterateBoardPeople(board, function (person) {
        that.addPerson(person);
      });
      this.set('board', board, silent);
    },
    iterateBoardPeople: function iterateBoardPeople(board, fn) {
      var members = board ? board.getMembers() : [],
        person = null,
        len = members ? members.length : 0,
        i = 0;
      for (i = 0; i < len; ++i) {
        person = members[i];
        if (person && fn) {
          fn(person);
        }
      }
    },
    addPerson: function addPerson(person) {
      var people = this.getMeetingPeople(),
        len = people ? people.length : 0,
        p = null,
        i = 0;
      for (i = 0; i < len; ++i) {
        p = people[i];
        if (p.person.id == person.id) {
          return false;
        }
      }
      people.push(MeetingPerson.model({
        person: person,
        meetingId: this.getId()
      }));
      this.trigger('change:people');
      return true;
    },
    removePerson: function removePerson(person) {
      var people = this.getMeetingPeople(),
        len = people ? people.length : 0,
        p = null,
        found = false,
        i = 0;
      for (i = 0; i < len; ++i) {
        p = people[i];
        if (p.person.id == person.id) {
          people.splice(i, 1);
          found = true;
          break;
        }
      }
      if (found) {
        this.trigger('change:people');
      }
      return this;
    },
    addDocument: function addDocument(doc) {
      var meetingDocuments = this.getMeetingDocuments(),
        meetingDocument = null,
        i = 0;
      for (i = 0; meetingDocument = meetingDocuments[i]; ++i) {
        if (meetingDocument.getDocument().id == doc.id) {
          return this;
        }
      }
      meetingDocument = new MeetingDocument({
        document: doc,
        meeting: this
      });
      meetingDocuments.push(meetingDocument);
      this.trigger('change:meetingDocuments');
      return this;
    },
    removeDocument: function removeDocument(doc) {
      var meetingDocuments = this.getMeetingDocuments(),
        len = meetingDocuments ? meetingDocuments.length : 0,
        d = null,
        found = false,
        i = 0;
      for (i = 0; i < len; ++i) {
        d = meetingDocuments[i];
        if (d && d.document && d.document.id == doc.id) {
          meetingDocuments.splice(i, 1);
          found = true;
          break;
        }
      }
      if (found) {
        this.trigger('change:meetingDocuments');
      }
      return this;
    },
    requestCreate: function requestCreate() {
      return this.constructor.requestCreate(this).bind(this).then(function (meeting) {
        this.updateWithServerProperties(meeting);
        this.setDocuments(meeting.documents);
        this.setPeople(meeting.people);
        return this;
      });
    },
    requestUpdate: function requestUpdate() {
      return this.constructor.requestUpdate(this.getId(), this).bind(this).then(function (meeting) {
        this.setDocuments(meeting.documents);
        this.setPeople(meeting.people);
        this.updateWithServerProperties(meeting);
        return this;
      });
    },
    requestSync: function requestSync() {
      if (this.getId() == null) {
        return this.requestCreate();
      }
      return this.requestUpdate();
    },
    requestDelete: function requestDelete() {
      return this.constructor.requestDelete(this.getId());
    },
    toJSON: function toJSON() {
      var json = this._super.apply(this, arguments);
      json.people = _.map(this.getMeetingPeople(), function (meetingPerson) {
        return {
          person: {
            id: meetingPerson.person.id
          }
        };
      });
      json.documents = _.map(this.getMeetingDocuments(), function (meetingDocument) {
        return {
          document: {
            id: meetingDocument.getDocument().id
          }
        };
      });
      if (json.endDate) {
        json.endDate = json.endDate.getTime();
      }
      if (json.startDate) {
        json.startDate = json.startDate.getTime();
      }
      return json;
    }
  }, {
    rootURI: '/rs/api/',
    parsers: {
      '#GET#meeting/:id': function GETMeeting_Id(data) {
        return this.model(data);
      },
      '#PUT#meeting/:id': function PUTMeeting_Id(data) {
        return data;
      },
      'meeting/:start/:end': function meeting_Start_End(data) {
        return this.models(data);
      },
      'meeting/:boardId/:start/:end': function meeting_BoardId_Start_End(data) {
        return this.models(data);
      },
      'meetingDocument/:id': function meetingDocument_Id(data) {
        return this.models(data);
      },
      'meetingNotes/:documentId': function meetingNotes_DocumentId(data) {
        return MeetingDocument.models(data);
      }
    },
    requestOne: function requestOne(id) {
      return this.get('meeting/' + id);
    },
    requestAll: function requestAll(start, end) {
      return this.get('meeting/' + start + '/' + end);
    },
    requestAllByDocumentId: function requestAllByDocumentId(docId) {
      return this.get('meeting/document/' + docId);
    },
    requestAllByBoardId: function requestAllByBoardId(boardId, start, end) {
      return this.get('meeting/' + boardId + '/' + start + '/' + end);
    },
    requestCreate: function requestCreate(data) {
      return this.post('meeting', data, {
        jsonBody: true
      });
    },
    requestUpdate: function requestUpdate(id, data) {
      return this.put('meeting/' + id, data, {
        jsonBody: true
      });
    },
    requestDelete: function requestDelete(id) {
      return this.del('meeting/' + id);
    },
    requestNotes: function requestNotes(documentId) {
      return this.get('meetingNotes/' + documentId);
    }
  });
  MeetingDocument.Meeting = Meeting;
  return Meeting;
});

